import { atom, useAtom } from 'jotai';

const globalOrderRequestLoadingAtom = atom(false);

// Global loading state for order creation/modification (prevents multiple order submissions from different widgets)
export const useGlobalOrderRequestLoading = () => {
  const [isGlobalOrderRequestLoading, setIsGlobalOrderRequestLoading] = useAtom(globalOrderRequestLoadingAtom);

  return {
    isGlobalOrderRequestLoading,
    setIsGlobalOrderRequestLoading,
  };
};
